<template>
    <div >
        <div style="margin: 0px; padding: 0px;">
            <div style="background: #FFFFFF; color: #666666; padding-top: 5px; padding-bottom: 5px; font-weight: 400; text-align: center; width: 100%; font-size: 12px; font-family: PingFangSC-Regular, PingFang SC;">
                <span>开发者：北京中网易企秀科技有限公司</span><br/>
                <span>应用名称：易企秀设计</span> <span style="padding-left: 20px;">版本号：5.24.0</span><br/>
                <span><a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">用户权限</a> | <a href="http://lps.eqxiul.com/ls/d2OO1JzU" style="color: #246DFF;">隐私协议</a></span>
            </div>
            <img :src="awaken_img" style="width: 100%; display: block;" title="awaken">
        </div>
        <div class="wxtip" v-show="wxtip">
            <img :src="awaken_img_wx_tip" style="width: 60%; padding-right: 16px;"/>
        </div>
    </div>
</template>

<script>
    import MobileDetect from 'mobile-detect'

    export default {
        name: "middle",
        data() {
            return {
                awaken_img: "//lib.eqh5.com/app/eqxiu-logo.png",
                awaken_img_wx_tip: '//asset.eqh5.com/app_awaken_wxtip?t=' + new Date().getTime(),
                wxtip: false
            }
        },
        mounted() {
            var params = this.$route.query
            if (this.isWx()) {
                this.wxtip = true;
            } else {
                this.wxtip = false;
                params.fn = "eqxiu"
                params.channelCode = "9zn-lb"
                /**
                 * 1： vip 会员
                 2 ：专业版会员
                 3:   app 会员
                 */
                if (this.isiOS()) {
                    if (params.type == 3) {
                        params.target = 72
                    } else if (params.type == 2) {
                        params.target = 76
                    }
                } else {
                    if (params.type == 2 || params.type == 3) {
                        params.target = 31
                    }
                }
                if (this.isEqxiu()) {
                    if (this.isiOS()) {
                        window.webkit.messageHandlers.jsInterfacePlus.postMessage({
                            type: 5,
                            json: JSON.stringify(params)
                        })
                    } else {
                        window.EqxApp.jsInterfacePlus(5, JSON.stringify(params))
                    }
                } else {
                    this.$router.push({
                        name: 'awaken',
                        query: params
                    })
                }
            }
        },
        methods: {
            isiOS() {
                var md = new MobileDetect(navigator.userAgent.toLowerCase())
                var os = md.os();
                if (os == "iOS") {
                    return true;
                }
                return false;
            },
            isWx(){//判断是否为微信
                if(navigator.userAgent.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'){
                    return true;
                }
                return false;
            },
            isEqxiu(){//判断是否为eqxiu app
                let ua = navigator.userAgent.toLowerCase();
                if(ua.indexOf("eqxiu") > -1){
                    return true;
                }
                return false;
            }
        }
    }
</script>

<style scoped>
    .wxtip {
        background: rgba(0,0,0,0.8);
        text-align: right;
        position: fixed;
        left:0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 998;
    }
</style>
